/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckKdsUpdatesRequest
 */
export interface CheckKdsUpdatesRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckKdsUpdatesRequest
     */
    platform: string;
    /**
     * 
     * @type {string}
     * @memberof CheckKdsUpdatesRequest
     */
    appVersion: string;
    /**
     * 
     * @type {string}
     * @memberof CheckKdsUpdatesRequest
     */
    channel?: string;
}

/**
 * Check if a given object implements the CheckKdsUpdatesRequest interface.
 */
export function instanceOfCheckKdsUpdatesRequest(value: object): value is CheckKdsUpdatesRequest {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('appVersion' in value) || value['appVersion'] === undefined) return false;
    return true;
}

export function CheckKdsUpdatesRequestFromJSON(json: any): CheckKdsUpdatesRequest {
    return CheckKdsUpdatesRequestFromJSONTyped(json, false);
}

export function CheckKdsUpdatesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckKdsUpdatesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'appVersion': json['appVersion'],
        'channel': json['channel'] == null ? undefined : json['channel'],
    };
}

export function CheckKdsUpdatesRequestToJSON(json: any): CheckKdsUpdatesRequest {
    return CheckKdsUpdatesRequestToJSONTyped(json, false);
}

export function CheckKdsUpdatesRequestToJSONTyped(value?: CheckKdsUpdatesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'appVersion': value['appVersion'],
        'channel': value['channel'],
    };
}

